import { useIsFocused } from "expo-router/react-navigation";
import { router } from 'expo-router';
import { useLayoutEffect } from 'react';
import { SubmitHandler } from 'react-hook-form';

import { useNpoOnboarding } from '@/api/hooks/meHooks';
import { useUpdateNonProfitOrg } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrg } from '@/api/models/nonProfitOrgModels';
import NpoLandEquipmentsForm from '@/components/forms/NpoLandEquipmentsForm';
import { useAuth } from '@/contexts/authContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { LandEquipmentsData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const LandEquipments = () => {
  const { state: authState } = useAuth();
  const { state: npoScreensState, setCurrentPage } = useNpoLoginScreenState();
  const { mutateAsync: onBoardingUpdate, isPending: onBoardingIsPending } = useNpoOnboarding(
    authState.signUpData?.loginEmail?.type ?? 'CHURCH'
  );
  const { mutateAsync: nonProfitUpdate, isPending: nonProfitIsPending } = useUpdateNonProfitOrg();

  const isFocused = useIsFocused();
  useLayoutEffect(() => {
    if (isFocused) setCurrentPage(11);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  const nonProfitOrg = safeJsonParse<NonProfitOrg>(npoScreensState.initialNpoData ?? '');

  const onSubmit: SubmitHandler<LandEquipmentsData> = async (data) => {
    try {
      nonProfitUpdate(
        {
          npoId: authState.signUpData?.loginEmail?.npoId ?? '',
          totalLandBuildingEquiment: data.totalLandBuildingEquiment
        },
        {
          onSuccess: () => {
            onBoardingUpdate(
              {
                preferenceId: authState.preferenceId ?? '',
                landEquipments: true
              },
              {
                onSuccess: () => {
                  router.navigate('/(app)/login/nonProfit/onBoarding/fundraising');
                }
              }
            );
          },
          onError: (e) => {
            console.error(e);
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <NpoLandEquipmentsForm
      nonProfitOrg={nonProfitOrg}
      isLoading={onBoardingIsPending || nonProfitIsPending}
      onSubmitTapped={onSubmit}
    />
  );
};

export default LandEquipments;
